<template>
<div>
    <el-dialog
        :title="title"
        :visible.sync="dialogVisible"
        width="70%"
        :before-close="closeDialog">
        <div class="container">
            <img class="phoneImg"  :src="baseUrl + content.image"/>
            <div class="content">
            <div class="contentTit">{{content.title}}</div>
            <div class="conBox">
                <div class="conItem">
                <span class="label">软件版本：</span><span class="value">{{content.version}}</span>
                </div>
                <div class="conItem conItem2">
                <span class="label">发布时间：</span><span class="value">{{content.publishTime}}</span>
                </div>
            </div>
            <div class="conBox">
                <div class="conItem"><span class="label">软件描述：</span><span class="value">{{content.describe}}</span></div>
            </div>
            <!-- <div class="blueBtn" @click="handleApplay">申请应用</div> -->
            </div>
        </div>
        <div slot="footer" class="dialog-footer">
            <!-- <el-button @click="closeDialog">取 消</el-button> -->
            <template v-if="applyStatus === 0">
              <el-button type="primary" class="myBtn" @click="goApply">申请</el-button>
            </template>
        </div>
    </el-dialog>
    <MarketDialog ref="marketDialog" :id="content.id"></MarketDialog>
    </div>
</template>
<script>
 import {
    serverUrl
 } from '@/utils/server.js'
 import {
    fetchAplicationById
  } from '@/api/api'
 import MarketDialog from '@/components/marketDialog.vue'
export default {
  data() {
    return {
      dialogVisible: false,
      baseUrl: serverUrl.baseURL,
      content: {},
      applyStatus:  0,
    }
  },
  components: {
    MarketDialog
  },
  created() {

  },
  methods:{
      goApply() {
        this.closeDialog()
        var that = this
         that.$refs.marketDialog.openDialog(this.content.title, 2)
      },
      openDialog(id, applyStatus) {
        this.dialogVisible = true
        this.getApplicationById(id)
        this.applyStatus = applyStatus
      },
      closeDialog() {
        this.dialogVisible = false
      },
      getApplicationById(id) {
        fetchAplicationById({id: id}).then(res=> {
          this.content = res.data
        })
      }
  }
}
</script>
<style scoped>
.container{
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  /* padding-bottom: 100px; */
}
.phoneImg{
  width: 435px;
  margin-right: 30px;
  /* border: 1px solid #f00; */
}
.content{
  width: 564px;
}
.contentTit{
  font-size: 24px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #121E30;
  margin-bottom: 46px;
}
.conItem{
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #8995A8;
  line-height: 30px;
}
.conItem .label {
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #8995A8;
}
.conItem .value{
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #121E30;
}
.conBox{
  margin-bottom: 36px;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
}
.conItem2{
  margin-left: 84px;
}
.blueBtn{
  background: #0F5EFF;
  box-shadow: 1px 4px 24px 0px rgba(110,154,229,0.57);
  border-radius: 30px;
  font-size: 12px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: #FFFFFF;
  line-height: 36px;
  padding: 10px 76px;
  display: inline-block;
  cursor: pointer;
}

.myBtn{
  background: #0F5EFF;
  border-radius: 30px;
  font-size: 22px;
  font-family: Source Han Sans CN;
  color: #FFFFFF;
  line-height: 36px;
  padding: 8px 76px;
  display: inline-block;
  cursor: pointer;
}

/deep/ .el-dialog__footer {
  text-align: center;
}

</style>



// WEBPACK FOOTER //
// src/views/console/components/AppDetailDialog.vue